module.exports = __webpack_public_path__ + "static/media/kp.78685ce6.svg";